/**
 * LURU scroll reveal — plays each [data-reveal] element's entrance once,
 * the first time it scrolls into view. Progressive enhancement: content
 * stays fully visible until this script confirms it can animate it in,
 * so a slow/blocked/errored load never leaves anything invisible.
 */
(function () {
  var ROOT = document.documentElement;
  var SELECTOR = '[data-reveal]';
  var REVEALED = 'is-revealed';
  var READY = 'luru-reveal-ready';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || typeof IntersectionObserver === 'undefined') {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(REVEALED);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function observe(root) {
    var items = (root || document).querySelectorAll(SELECTOR);
    items.forEach(function (el) {
      if (el.classList.contains(REVEALED)) return;
      observer.observe(el);
    });
  }

  ROOT.classList.add(READY);
  observe(document);

  // Re-scan sections added/reloaded by the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
